import React, {useCallback, useEffect, useState} from 'react'

export function useScroll(ref: React.RefObject<HTMLDivElement> | HTMLDivElement | null, initValue = 0): number {
  const [scroll, setScroll] = useState(initValue)

  const handleScroll = useCallback(() => {
    const htmlElement = ref instanceof HTMLDivElement ? ref : ref?.current
    if (!htmlElement) return

    setScroll(htmlElement.scrollTop)
  }, [ref])

  useEffect(() => {
    const htmlElement = ref instanceof HTMLDivElement ? ref : ref?.current
    if (!htmlElement) return

    htmlElement.addEventListener('scroll', handleScroll)
    return () => htmlElement.removeEventListener('scroll', handleScroll)
  }, [handleScroll, ref])

  return scroll
}